var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisrezLogoTextDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "-1 -1 2 2",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.137) scale(.55645)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -0.6,
  y1: 0.4242,
  x2: 0.6,
  y2: -0.4242
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0027C2",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#224A95",
  offset: 0.163
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#477066",
  offset: 0.362
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#638D40",
  offset: 0.552
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#78A325",
  offset: 0.726
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85AF15",
  offset: 0.881
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89B40F",
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M.6-.42L0 0l-1-.707 1-.707 1 .707v1L0 1l-1-.707V-.2",
  stroke: "url(#a)",
  strokeWidth: 0.224,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-.43.61l-.138.372h-.09l-.137-.37h.08l.103.295.1-.295zm.05.03A.041.041 0 01-.394.608c0-.012.003-.022.012-.03A.045.045 0 01-.35.564c.013 0 .025.003.033.012a.041.041 0 01.012.031.041.041 0 01-.012.032.045.045 0 01-.033.012A.045.045 0 01-.382.64zm.068.047v.295h-.075V.687zm.122.287A.115.115 0 01-.237.937a.09.09 0 01-.019-.05h.075a.044.044 0 00.017.028.059.059 0 00.038.013.053.053 0 00.032-.01A.025.025 0 00-.08.899c0-.01-.005-.016-.015-.021A.278.278 0 00-.142.861.396.396 0 01-.196.844.094.094 0 01-.232.818.07.07 0 01-.247.771c0-.017.005-.032.014-.045a.095.095 0 01.04-.033A.152.152 0 01-.13.682c.035 0 .063.009.084.026A.097.097 0 01-.012.78h-.073A.039.039 0 00-.097.752.055.055 0 00-.132.74c-.014 0-.025.002-.032.007a.025.025 0 00-.01.021c0 .01.004.018.014.023a.21.21 0 00.046.016.397.397 0 01.053.016.127.127 0 01.037.027.09.09 0 01.015.047.079.079 0 01-.016.046.092.092 0 01-.037.03.154.154 0 01-.063.013.156.156 0 01-.064-.013zM.165.696A.105.105 0 01.217.683v.078h-.02C.175.76.157.767.145.778.132.787.127.808.127.836v.146H.052V.687h.075v.046A.105.105 0 01.165.696zm.374.162H.325c.002.02.01.037.022.05.013.011.03.017.05.017A.067.067 0 00.453.89h.08a.135.135 0 01-.05.07.144.144 0 01-.087.028.154.154 0 01-.078-.02.134.134 0 01-.052-.053.164.164 0 01-.019-.08c0-.03.006-.057.019-.08A.13.13 0 01.32.7.156.156 0 01.396.682c.028 0 .053.006.075.019a.12.12 0 01.053.048.176.176 0 01.017.105zM.464.806A.059.059 0 00.444.76a.074.074 0 00-.05-.018.067.067 0 00-.046.019.075.075 0 00-.023.045h.14zm.2.113h.131v.063H.58V.92L.708.75H.58V.686h.213v.06z",
  fill: "current"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisrezLogoTextDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visrez-logo-text-down.620f25bf9a391859557be4496aae30a3.svg";